import { UserRoles } from './config';

export { UserRoles };



// WEBPACK FOOTER //
// ./src/services/userRole/index.ts